var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_373_38616)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5506 10.8862C20.1558 9.25993 17.8429 9.25993 17.4481 10.8862C17.193 11.9368 15.9894 12.4354 15.0662 11.8728C13.637 11.002 12.0016 12.6375 12.8724 14.0667C13.4349 14.9899 12.9363 16.1935 11.8857 16.4486C10.2594 16.8434 10.2594 19.1563 11.8857 19.5511C12.9363 19.8062 13.4349 21.0098 12.8724 21.933C12.0016 23.3621 13.637 24.9977 15.0662 24.1268C15.9894 23.5643 17.193 24.0629 17.4481 25.1135C17.8429 26.7397 20.1558 26.7397 20.5506 25.1135C20.8057 24.0629 22.0093 23.5643 22.9325 24.1268C24.3616 24.9977 25.9972 23.3621 25.1263 21.933C24.5638 21.0098 25.0624 19.8062 26.113 19.5511C27.7392 19.1563 27.7392 16.8434 26.113 16.4486C25.0624 16.1935 24.5638 14.9899 25.1263 14.0667C25.9972 12.6375 24.3616 11.002 22.9325 11.8728C22.0093 12.4354 20.8057 11.9368 20.5506 10.8862ZM18.9993 21.1248C20.7253 21.1248 22.1243 19.7258 22.1243 17.9998C22.1243 16.274 20.7253 14.8748 18.9993 14.8748C17.2735 14.8748 15.8743 16.274 15.8743 17.9998C15.8743 19.7258 17.2735 21.1248 18.9993 21.1248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32,
    height: 32,
    rx: 8,
    stroke: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_373_38616",
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_373_38616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_373_38616",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetting);
export default __webpack_public_path__ + "static/media/ProfileSetting.6c5a02ba527b79fca73f09241a02ae58.svg";
export { ForwardRef as ReactComponent };